import { MoreVertical, Heart, MessageCircle, Send } from "lucide-react";
import { getVideoURLBasedOnEvent } from "constants/media";
import { truncateText } from "./YoutubePostPreview";

const InstagramReelPreview = ({ selectedEvent, title }) => {
  const videoUrl = getVideoURLBasedOnEvent(selectedEvent);

  return (
    <div className="relative my-[1vh] w-full h-full bg-[#FFF] overflow-hidden rounded-lg shadow-md">
      {/* Video or Image Background */}
      <video
        className="w-full h-full object-contain"
        src={videoUrl}
        muted
        autoPlay
        loop
      />

      {/* Caption in Center */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 px-[2vh] text-center z-10"></div>

      {/* Right Side Actions */}
      <div className="absolute right-[1vh] top-2/3 -translate-y-1/2 flex flex-col items-center space-y-[4vh] text-[#444] text-[1.5vh] z-10 font-manropeSB">
        <div className="flex flex-col items-center text-[#FFF]">
          {/* Like Icon */}
          <Heart className="h-[2.5vh] w-[2.5vh] text-[#FFF]" />
          87.7K
        </div>
        <div className="flex flex-col items-center text-[#FFF]">
          <MessageCircle className="h-[2.5vh] w-[2.5vh] text-[#FFF]" />
          278
        </div>
        <div className="flex flex-col items-center text-[#FFF]">
          <Send className="h-[2.5vh] w-[2.5vh] text-[#FFF]" />
          {/* Share Icon */}
          79.1K
        </div>
        <div className="flex flex-col items-center">
          <MoreVertical className="h-[2.5vh] w-[2.5vh] text-[#FFF]" />
        </div>
      </div>

      {/* Bottom Info Row */}
      <div className="absolute bottom-[1.5vh] left-[1vh] right-[1vh] text-[#444] text-[1.6vh] z-10">
        <div className="flex items-center space-x-[1.5vh]">
          <div className="w-[4vh] h-[4vh] bg-red-200 rounded-full flex items-center justify-center text-red-500 font-bold text-[2vh]">
            S
          </div>
          <div className="text-[1.8vh]">
            <p className="font-manropeSB text-[#FFF]">Soomuch.ai</p>
          </div>
          <button className="text-[#FFF] font-medium text-[1.5vh] border border-[#FFF] px-[1vh] py-[0.5vh] rounded-md">
            Follow
          </button>
        </div>
        <div className="mt-[0.3vh] text-[1.6vh] text-[#FFF]">
          <span className="">{truncateText(title, 25)}</span>{" "}
        </div>
      </div>
    </div>
  );
};

export default InstagramReelPreview;
